import { type Slice } from "prosemirror-model";
import { type EditorView } from "prosemirror-view";
import { useCallback } from "react";

import { hydrateDropComponentTemplate } from "~/components/common/dnd";

import { usePropertiesPane } from "../easel/properties-pane/usePropertiesPane";
import { useEaselInsertTemplateAtPos } from "./useEaselInsertTemplateAtPos";

/**
 * Returns a callback intended to be passed to the `handleDrop` prop of the NYT `ProseMirror`
 * component. This callback will handle the drag-and-drop semantics for the editor, including
 * inserting templates.
 */
export const useEaselProseMirrorDropHandler = () => {
	const insertTemplateAtPos = useEaselInsertTemplateAtPos();
	const { closePane } = usePropertiesPane();

	return useCallback(
		(view: EditorView, e: DragEvent, _slice: Slice) => {
			const template = hydrateDropComponentTemplate(e);
			const insertPos = view.posAtCoords({ left: e.clientX, top: e.clientY });

			let tr = view.state.tr;

			if (template && insertPos) {
				tr = insertTemplateAtPos(tr, template, insertPos.pos);
				closePane();
			}

			view.dispatch(tr);
			view.focus();
		},
		[closePane, insertTemplateAtPos]
	);
};
